// =============================================================
// 😍 EmotionAnalysis.jsx — Análise de emoções das mensagens
// =============================================================

import React, { useEffect, useState } from "react";
import { listenAllMessages } from "../../../services/iaDashboard/messagesService";
import { extractEmotionStats } from "../../../services/iaDashboard/insightsService";

export default function EmotionAnalysis() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const unsub = listenAllMessages((messages) => {
      const result = extractEmotionStats(messages || []);
      setStats(result);
    });

    return () => unsub && unsub();
  }, []);

  if (!stats)
    return <div className="ia-chart-empty">Coletando emoções...</div>;

  return (
    <div className="ia-insight-card">
      <div className="ia-insight-title">Análise Emocional</div>

      {Object.entries(stats).map(([emotion, value]) => (
        <div key={emotion} style={{ marginBottom: 8 }}>
          <strong style={{ color: "#c2185b" }}>
            {emotion.charAt(0).toUpperCase() + emotion.slice(1)}:
          </strong>

          <div
            style={{
              marginTop: 4,
              height: 8,
              background: "#fce4ec",
              borderRadius: 8,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${value}%`,
                height: "100%",
                background: "#d81b60",
              }}
            ></div>
          </div>

          <div style={{ fontSize: 11, color: "#777", marginTop: 2 }}>
            {value.toFixed(1)}%
          </div>
        </div>
      ))}
    </div>
  );
}
